module.exports = __webpack_public_path__ + "img/macro2.8045101b.jpg";